import React from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Checkbox,
  Chip,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { formatoPesoArgentino } from "../../../services/library";

// Grupo desplegable (por cliente o por producto) con selección por grupo y por ítem
function GrupoPrecios({
  titulo,
  subtitulo,
  items,
  etiquetaItem,
  detalleItem,
  seleccion,
  onToggleItem,
  onToggleGrupo,
  expandido,
  onToggleExpandido,
}) {
  const cantSeleccionados = items.filter((item) => seleccion[item.id]).length;
  const todos = cantSeleccionados === items.length;
  const algunos = cantSeleccionados > 0 && !todos;

  return (
    <Accordion
      expanded={expandido}
      onChange={onToggleExpandido}
      disableGutters
      TransitionProps={{ unmountOnExit: true }}
      sx={{
        mb: 1,
        borderRadius: 2,
        "&:before": { display: "none" },
        border: "1px solid",
        borderColor: cantSeleccionados > 0 ? "#2471A3" : "#e0e0e0",
        boxShadow: "none",
        overflow: "hidden",
      }}
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
          backgroundColor: cantSeleccionados > 0 ? "#EBF5FB" : "#ffffff",
          "& .MuiAccordionSummary-content": { alignItems: "center", gap: 1, my: 0.5 },
        }}
      >
        <Checkbox
          checked={todos}
          indeterminate={algunos}
          onClick={(e) => e.stopPropagation()}
          onChange={() => onToggleGrupo(items, !todos)}
        />
        <Box flexGrow={1} minWidth={0}>
          <Typography fontWeight="bold" noWrap>
            {titulo}
          </Typography>
          {subtitulo && (
            <Typography variant="body2" color="text.secondary" noWrap>
              {subtitulo}
            </Typography>
          )}
        </Box>
        {cantSeleccionados > 0 && (
          <Chip
            size="small"
            color="primary"
            label={`${cantSeleccionados} sel.`}
          />
        )}
        <Chip
          size="small"
          variant="outlined"
          label={items.length}
          sx={{ mr: 1 }}
        />
      </AccordionSummary>
      <AccordionDetails sx={{ p: 0 }}>
        {items.map((item) => (
          <Box
            key={item.id}
            display="flex"
            alignItems="center"
            px={2}
            py={0.25}
            onClick={() => onToggleItem(item.id)}
            sx={{
              cursor: "pointer",
              borderTop: "1px solid #f0f0f0",
              backgroundColor: seleccion[item.id] ? "#F4F9FD" : "transparent",
              "&:hover": { backgroundColor: "#F2F4F4" },
            }}
          >
            <Checkbox
              size="small"
              checked={!!seleccion[item.id]}
              onClick={(e) => e.stopPropagation()}
              onChange={() => onToggleItem(item.id)}
            />
            <Box flexGrow={1} minWidth={0}>
              <Typography variant="body2" noWrap>
                {etiquetaItem(item)}
              </Typography>
              {detalleItem && (
                <Typography variant="caption" color="text.secondary" noWrap>
                  {detalleItem(item)}
                </Typography>
              )}
            </Box>
            <Typography variant="body2" fontWeight="bold" whiteSpace="nowrap">
              {formatoPesoArgentino(item.precio_minimo)}
            </Typography>
          </Box>
        ))}
      </AccordionDetails>
    </Accordion>
  );
}

export default GrupoPrecios;
